export default __webpack_public_path__ + "static/media/minim.a5424144.png";